import { render, staticRenderFns } from "./VasionSelectWorkflow.vue?vue&type=template&id=108fa6d1&scoped=true&"
import script from "./VasionSelectWorkflow.vue?vue&type=script&lang=js&"
export * from "./VasionSelectWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./VasionSelectWorkflow.vue?vue&type=style&index=0&id=108fa6d1&prod&lang=scss&"
import style1 from "./VasionSelectWorkflow.vue?vue&type=style&index=1&id=108fa6d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108fa6d1",
  null
  
)

export default component.exports